import { render } from "./AmazonConnectionPage.vue?vue&type=template&id=4dd9f2b8"
import script from "./AmazonConnectionPage.vue?vue&type=script&lang=js"
export * from "./AmazonConnectionPage.vue?vue&type=script&lang=js"

import "./AmazonConnectionPage.vue?vue&type=style&index=0&id=4dd9f2b8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__